import { themeVariables } from "Components/theme";
import { WebGL2PolylineEdgeStyle } from "yfiles";
import buildStroke from "./buildStroke";
const webGL2EdgeStyles = {
    default: new WebGL2PolylineEdgeStyle({
        targetArrow: "default",
        sourceArrow: "none",
        stroke: buildStroke(themeVariables["gray-400"], false)
    }),
    defaultSelected: new WebGL2PolylineEdgeStyle({
        targetArrow: "default",
        sourceArrow: "none",
        stroke: buildStroke(themeVariables["brand-primary-500"], true)
    })
};
export default webGL2EdgeStyles;
